/**
 * Cross-component "the balance changed" signal for the External portal (Phase 6a review). Every
 * `useBilling()` instance fetches its own summary; a purchase settled on `/portal/buy/return` or a credit
 * consumed on the Analyse page would otherwise leave the AppBar `AnalysesChip` stale until the next
 * mount. Emitters fire AFTER their own refresh; subscribers re-fetch (only when enabled).
 */
export const BILLING_CHANGED_EVENT = 'dris:billing-changed';

export function emitBillingChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BILLING_CHANGED_EVENT));
}

/** Subscribe; returns the unsubscribe function (use as an effect cleanup). */
export function subscribeBillingChanged(cb: () => void): () => void {
  if (typeof window === 'undefined') return () => undefined;
  window.addEventListener(BILLING_CHANGED_EVENT, cb);
  return () => window.removeEventListener(BILLING_CHANGED_EVENT, cb);
}
